import component from "js/legacy/unavailable-alert"

export default component
